<div class="indicator-wrapper">
  <span class="indicator-text">
    {{ value | translateEnum: 'TenantStatus' }}
  </span>
</div>